import { useState } from "react";

import { EditIcon } from "@dotnet/telematics-design-system";

import {
    isAllowedToEditCompany,
    RenderConditionOptions,
    usePermissions
} from "shared";

import { TITLES } from "../constants";

const useCompanyInlineActions = () => {
    const { PERMISSIONS, getNoPermissionTooltipTitle } = usePermissions();

    const [rowData, setRowData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const openDialog = (data: any) => {
        setRowData(data);
        setIsOpen(true);
    };

    const closeDialog = () => {
        setRowData(null);
        setIsOpen(false);
    };

    const inlineActions = [
        {
            title: TITLES.EditCompany,
            icon: EditIcon,
            getDisabledText: () =>
                getNoPermissionTooltipTitle(PERMISSIONS.CompanyUpdate),
            clickAction: (data: any) => openDialog(data),
            renderConditions: ({ data, user }: RenderConditionOptions) =>
                isAllowedToEditCompany(user!.access_level, data.type, data.code)
        }
    ];

    return {
        inlineActions,
        rowData,
        isOpen,
        closeDialog
    };
};

export { useCompanyInlineActions };
